define('components/decorator',[
    'jquery'
], function($) {

    $.ajaxSetup({ cache: false });

    $.extend(companyInfo.decorators, {

        'checkbox-options': function(){
            var $el = $(this);
            var opts = $el.find('.checkbox-options button');
            var checks = $el.find(':checkbox');
            var selectAll = checks.filter('[data-handler*=toggle-checkboxes]');
            var itemChecks = checks.filter(':not([data-handler*=toggle-checkboxes])');
            var deleteTotal = opts.filter('[name=delete-multiple]');

            function check(){
                opts.prop('disabled',checks.filter(':checked').length === 0);

                //count all the checked checkboxes
                if(selectAll.is(":checked")) {
                    deleteTotal.attr("data-count", "all");
                }
                else {
                    var selectedCount = 0;
                    itemChecks.each(function (index, item) {
                        if(item.checked) {
                            selectedCount++;
                        }
                    });

                    deleteTotal.attr("data-count", selectedCount);
                }
            }
            var timeout;
            function debouncedCheck(){
                clearTimeout(timeout);
                timeout = setTimeout(check,100);
            }
            $el.on('change',':checkbox',debouncedCheck);
            check();
        },

        'toggle-extra-options': function(e) {
            var $this = $(this);
            $this.prev('.form-element').find('input').on('click', function() {
                if (this.getAttribute('data-show-extra-options') && this.getAttribute('data-show-extra-options') == 'true') {
                    $this.show();
                } else {
                    $this.hide();
                }
            }).filter('[data-show-extra-options]:checked').each(function() {
                $this.show();
            });

            $this.prev('.form-element').find('select').first().on('change', function() {
                var extraOptionsName = $(this).find('option:selected').data('extra-options-name');
                var elToShow = $this.children().filter(function(i, child) {
                   return child.dataset.extraOptionsName === extraOptionsName;
                });
                var elToHide = $this.children().filter(function(i, child) {
                  return child.dataset.extraOptionsName !== extraOptionsName;
                });
                if (elToShow.length) {
                  elToShow.show();
                }
                if (elToHide.length) {
                    elToHide.each(function(i) {
                       elToHide.eq(i).hide();
                    });
                }
            }).find('option[data-show-extra-options]:selected').each(function() {
                var extraOptionsName = $(this).data('extra-options-name');
                var elToShow = $this.children().filter(function(i, child) {
                  return child.dataset.extraOptionsName === extraOptionsName;
                });
                if (elToShow.length) {
                    elToShow.show();
                }
            });
        },

        'toggle-emergencydesk': function(e) {
            $(this).on('click', function() {
                if (this.checked) {
                    $('#mailExtract').addClass('less-important');
                    $('#mailExtract').find('input').attr('checked', false).prop('disabled', true);
                    $('#faxExtract').addClass('less-important');
                    $('#faxExtract').find('input').attr('checked', false).prop('disabled', true);
                    $('#extractfaxnrrow').hide();
                } else {
                    $('#mailExtract').removeClass('less-important');
                    $('#mailExtract').find('input').prop('disabled', false);
                    $('#faxExtract').removeClass('less-important');
                    $('#faxExtract').find('input').prop('disabled', false);
                }
            });
        },

        'toggle-fax-number': function(e) {
            $(this).on('click', function() {
                if (this.checked) {
                    $('#extractfaxnrrow').show();
                } else {
                    $('#extractfaxnrrow').hide().find('input').val('');
                }
            });
        },

        'fax-number': function(e) {
            $(this).on('blur', function() {
                this.value = this.value.replace(/-|(|)|s/gi, '');
            });
        },

        'toggle-dgu-order': function(e) {

            $(this).on('click', function() {
                var component = $(this).parents('li');
                if ( this.checked && this.getAttribute('data-change-handler') == 'true' ) {
                    component.append('<div id="loader"><i class="ico ico-spinner ico-spin"></i></div>');
                    // check if English is av.
                    var data = [];
                    data.push({name: 'itemEncoded', value: this.value});
                    $.ajax({
                        url: $(this).attr('data-url'),
                        type: 'get',
                        data: $.param(data)
                    }).done( function(data, textStatus, jqXHR) {
                        data = data.responseText || data;
                        $("#loader").remove();
                        component.append('<div id="dgu-language">' + data + '</div>');
                    }
                    ).fail(function(jqXHR, textStatus, errorThrown) {
                        $("#loader").remove();
                        component.append('<div class="form-element"><strong>' + companyInfo.labels.serverError + '</strong></div>');
                    });

                } else {
                    $("#dgu-language").remove();

                }
            });
        },

        'resize-iframe': function(e) {
            if (this.contentWindow) {
                this.style.height = ($(this.contentWindow.document.body).height() + 30) + 'px';
                if (companyInfo.ie) {
                    $(this).parent().addClass('ie8fix');
                }
            }
            $(this).load(function() {
                this.style.height = ($(this.contentWindow.document.body).height() + 30) + 'px';
                if (companyInfo.ie) {
                    $(this).parent().addClass('ie8fix');
                }
            });
        },

        'meters': function() {
            $(this).find('em').each(function() {
                $(this).css({paddingLeft: $(this).text()});
            });
        },

        'handlers': function() {
            var el = this;

            /**
             * Waarde tussen 1 t/m X die vertaald naar scherm breedte categorie:
             * 1 = small
             * 2 = medium
             * 3 = large
             * 4+ = full
             * @returns {number}
             */
            companyInfo.size = function() {
                // IE8 doesn't support this, assume 'big screen'
                if (companyInfo.ie) {
                    return 5;
                }
                if (window.getComputedStyle) {
                    var pseudo = window.getComputedStyle(el, ':before').getPropertyValue('content');
                    return pseudo ? pseudo.replace(/['"]/g, '') : false;
                } else {
                    return false;
                }
            };

            $(this).on('click', '[data-handler]', function(e) {
                var i;
                var handlers = this.getAttribute('data-handler').split(/\s+/);
                // Allow keyboard modifiers to work on normal anchors
                if (e.target.tagName == 'A' && (e.metaKey || e.shiftKey || e.ctrlKey || e.altKey)) {
                    return;
                }
                for (i = 0; i < handlers.length; i++) {
                    if (companyInfo.handlers[handlers[i]]) {
                        companyInfo.handlers[handlers[i]].call(this, e);
                    }
                }
            }).on('change', '[data-change-handler]', function(e) {
                var handler = this.getAttribute('data-change-handler');
                switch (handler) {
                    case 'switch-search':
                        var selected = this.options[this.selectedIndex];
                        var q = $('#q');

                        q.attr({
                            'placeholder': ' '+selected.getAttribute('data-placeholder'),
                            'data-source': selected.getAttribute('data-source'),
                            'data-redirect-url': selected.getAttribute('data-redirect-url'),
                            'data-decorator': 'autosuggest'
                        }).removeAttr('data-decorated').select2('destroy');

                        require(['components/decorator'], function(decorator) {
                            decorator.run(q.parent());
                            q.focus();
                        });
                        break;
                }
            }).on('click', 'h2', function(e) {
                var clicked = e.target.tagName.toLowerCase();
                if (clicked != 'button' && clicked != 'a' && clicked != 'select' && clicked != 'option' && clicked != 'input' && clicked != 'label' && $(e.target).closest('.options').length === 0) {
                    var size = companyInfo.size();
                    if (size && size <= 2) {
                        $(this).toggleClass('closed').next().attr('tabindex', -1).focus();
                        if (!$(this).hasClass('closed')) {
                            $('html, body').animate({
                                scrollTop: $(this).offset().top
                            }, companyInfo.transitions);
                        }
                    }
                }
            }).on('submit', 'form', function(e) {

                var form = $(this);

                if (form.hasClass('submitted')) {
                    e.preventDefault();
                }
                form.addClass('submitted');
                setTimeout(function() {
                    form.removeClass('submitted');
                }, 10000);

                if (form.attr('enctype')) {
                    return;
                }

                var panelEditing = form.closest('.panel-editing');
                var data;

                if (panelEditing.length) {
                    data = form.serializeArray();
                    data.push({name: 'partial', value: 'true'});

                    $.ajax({
                        url: $(this).attr('action'),
                        type: $(this).attr('method'),
                        data: $.param(data)
                    }).done(function(data, textStatus, jqXHR) {
                        data = data.responseText || data;
                        var panel = panelEditing.closest('.panel');
                        if (jqXHR && jqXHR.getResponseHeader('X-Validation-Required')) {
                            var html = $('<div>').append($.parseHTML(data)).find('.panel-content > *');
                            if ( !html.length ) {
                                html = data;
                            }
                            panelEditing.html(html);
                            require(['components/decorator'], function(decorator) {
                                decorator.run(panelEditing);
                            });
                        } else {
                            if (panel[0].id) {
                                var response = $('<div>').append($.parseHTML(data)).find('#' + panel[0].id + ' > *');
                                panel.html(response);
                            } else {
                                panel.html(data);
                            }
                            require(['components/overlay', 'components/decorator'], function(overlay, decorator) {
                                overlay.hide({panel: panel});
                                decorator.run(panel);
                            });
                        }
                    }).fail(function(jqXHR, textStatus, errorThrown) {
                        form.append('<div class="form-element"><strong>' + companyInfo.labels.serverError + '</strong></div>');
                    });
                    e.preventDefault();
                } else {

                    var handler = this.getAttribute('data-form-handler');
                    if (handler) {

                        data = form.serializeArray();
                        data.push({name: 'partial', value: 'true'});

                        switch (handler) {

                            case 'dictionary':
                                e.preventDefault();
                                $.ajax({
                                    url: $(this).attr('action'),
                                    type: $(this).attr('method'),
                                    data: $.param(data)
                                }).done(function(data, textStatus, jqXHR) {
                                    var response = $('<div>').append($.parseHTML(data)).find('#dictionary-results > *');
                                    var results = $('#dictionary-results');
                                    results.html(response);
                                    require(['components/decorator'], function(decorator) {
                                        decorator.run(results);
                                    });
                                    form.removeClass('submitted');
                                }).fail(function(jqXHR, textStatus, errorThrown) {
                                    form.append('<div class="form-element"><strong>' + companyInfo.labels.serverError + '</strong></div>');
                                });
                                break;

                            case 'benchmark-check':
                                var serialized = $.param(data);
                                var count = serialized.match(/benchmark/g);
                                var enough = false;
                                if (count) {
                                    count = count.length;
                                    if (count > 1) {
                                        enough = true;
                                    }
                                }
                                if (!enough) {
                                    e.preventDefault();
                                    alert(companyInfo.labels.atLeast2Companies);
                                }
                                break;

                            case 'delete':
                                var panel = form.closest('.panel');
                                form.find('.ico').removeClass('ico-trash-o').addClass('ico-spinner ico-spin');
                                data = form.serializeArray();
                                data.push({name: 'partial', value: 'true'});
                                $.ajax({
                                    url: $(this).attr('action'),
                                    type: $(this).attr('method'),
                                    data: $.param(data)
                                }).done(function(data, textStatus, jqXHR) {
                                    panel.html(data);
                                    require(['components/decorator'], function(decorator) {
                                        decorator.run(panel);
                                    });
                                }).fail(function(jqXHR, textStatus, errorThrown) {
                                    alert(companyInfo.labels.serverError);
                                });
                                e.preventDefault();
                                break;

                            case 'confirm':
                                if (!window.confirm(this.getAttribute('data-confirm'))) {
                                    form.removeClass('submitted');
                                    e.preventDefault();
                                }
                                break;

                            case 'login':
                                $('#login').removeClass('hidden').find('input:first').focus();
                                e.preventDefault();
                                break;

                        }
                    }
                }
            });

            // Polyfills for older browsers
            if (!('autofocus' in document.createElement('input'))) {
                $('[autofocus]').focus();
            }
        }

    });

    return {
        run: function(context) {
            context = context || document;
            var count = 0;
            $('[data-decorator]', context).each(function() {
                if (!this.hasAttribute('data-decorated')) {
                    var i;
                    var decorators = this.getAttribute('data-decorator').split(/\s+/);
                    var decorateMultiple = false;
                    var response;
                    for (i = 0; i < decorators.length; i++) {
                        if (companyInfo.decorators[decorators[i]]) {
                            response = companyInfo.decorators[decorators[i]].call(this);
                            if (decorateMultiple || response) {
                                decorateMultiple = true;
                            }
                            count++;
                        }
                    }
                    if (!decorateMultiple) {
                        this.setAttribute('data-decorated', 'true');
                    }
                }
            });
            PubSub.publishSync('DECORATION_FINISHED');
            return count;
        }
    };

});

